exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.router-link-active[data-v-63932f18] {\n    color: #41B883;\n}\n\n", ""]);

